import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  actions: {
    justifyContent: 'space-between',
  },
  logo: {
    maxWidth: '100%',
    maxHeight: '200px',
  },
  publicAccessSection: {
    padding: theme.spacing(2),
    border: '1px solid #d9e2ec',
    borderRadius: 8,
    backgroundColor: '#f8fafc',
  },
  publicAccessTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
}));
